import { Controller } from "@hotwired/stimulus"

// Handles thumbs up/down rating for synthesis sections
export default class extends Controller {
  static values = { section: String, uploadId: Number, currentRating: String }
  static targets = ["upButton", "downButton"]

  rate(event) {
    const rating = event.currentTarget.dataset.rating
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/uploads/${this.uploadIdValue}/synthesis_feedbacks/rate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({
        section: this.sectionValue,
        rating: rating
      })
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    })
  }
}
